import React, { Component } from 'react'

import { Row, Cell, Column } from '@/ui/Element'
import { Button } from '@/ui/Button'
import classNames from '@/helpers/classNames'

import Akademie from '@/media/svg/block-akademie.svg'
import AkademieHeader from '@/media/svg/block-akademie-header.svg'
import ImgTxt from '@/media/svg/block-img+text.svg'
import ImgTxtNoCTA from '@/media/svg/img-text-no-cta.svg'
import Image from '@/media/svg/block-image.svg'
import Infothek from '@/media/svg/block-infothek.svg'
import Text from '@/media/svg/block-text.svg'
import TextCTA from '@/media/svg/block-text-cta.svg'
import Close from '@/media/svg/close.svg'

class addContent extends Component {
  state = {
    selected: [],
  }

  select = item => {
    const selected = Array.from(this.state.selected)
    if (selected.includes(item)) {
      selected.splice(selected.indexOf(item), 1)
    } else {
      selected.push(item)
    }
    this.setState({ selected })
  }

  addNew = () => {
    this.props.addNew(this.state.selected)
  }

  render() {
    const { theme } = this.props

    return (
      <Column classes={['flex', 'add-component']}>
        <div className={classNames(theme, 'app-bar-inverse')}>
          <Row>
            <div className={classNames(theme, 'app-bar-inverse-item')}>Select items</div>
            <div className={classNames(theme, 'app-bar-inverse-item', 'left-margin-auto')}>
              <Button
                classes="success"
                styles={['va-middle', 'right-margin-24']}
                onClick={this.addNew}
              >
                Add Selected
              </Button>
              <Button classes="clean" styles="va-middle" onClick={this.props.goBuild}>
                <Close fill="currentColor" width="40" height="40" />
              </Button>
            </div>
          </Row>
        </div>
        <Row
          classes={[
            'flex-wrap',
            'narrow-container',
            'margin-0-auto',
            'padding-top-80',
            'text-center',
          ]}
        >
          <Cell size="33" classes={['flex-middle', 'flex-column', 'margin-bottom-48']}>
            <Text
              fill="currentColor"
              width="210"
              height="250"
              className={classNames(theme, 'new-content', {
                'new-content-selected': this.state.selected.includes('Card / Text only'),
              })}
              onClick={e => this.select('Card / Text only')}
            />
            Card / Text only
          </Cell>
          <Cell size="33" classes={['flex-middle', 'flex-column', 'margin-bottom-48']}>
            <TextCTA
              fill="currentColor"
              width="210"
              height="250"
              className={classNames(theme, 'new-content', {
                'new-content-selected': this.state.selected.includes('Card / Text only + CTA'),
              })}
              onClick={e => this.select('Card / Text only + CTA')}
            />
            Card / Text only + CTA
          </Cell>
          <Cell size="33" classes={['flex-middle', 'flex-column', 'margin-bottom-48']}>
            <ImgTxt
              fill="currentColor"
              width="210"
              height="250"
              className={classNames(theme, 'new-content', {
                'new-content-selected': this.state.selected.includes('Card / Image + Text'),
              })}
              onClick={e => this.select('Card / Image + Text')}
            />
            Card / Image + Text
          </Cell>
          <Cell size="33" classes={['flex-middle', 'flex-column', 'margin-bottom-48']}>
            <ImgTxtNoCTA
              fill="currentColor"
              width="210"
              height="250"
              className={classNames(theme, 'new-content', {
                'new-content-selected': this.state.selected.includes(
                  'Card / Image + Text (no CTA)',
                ),
              })}
              onClick={e => this.select('Card / Image + Text (no CTA)')}
            />
            Card / Image + Text (no CTA)
          </Cell>
          <Cell size="33" classes={['flex-middle', 'flex-column', 'margin-bottom-48']}>
            <Image
              fill="currentColor"
              width="210"
              height="250"
              className={classNames(theme, 'new-content', {
                'new-content-selected': this.state.selected.includes('Card / Image'),
              })}
              onClick={e => this.select('Card / Image')}
            />
            Card / Image
          </Cell>
          <Cell size="33" classes={['flex-middle', 'flex-column', 'margin-bottom-48']}>
            <Akademie
              fill="currentColor"
              width="210"
              height="250"
              className={classNames(theme, 'new-content', {
                'new-content-selected': this.state.selected.includes('Card / Akademie'),
              })}
              onClick={e => this.select('Card / Akademie')}
            />
            Card / Akademie
          </Cell>
          <Cell size="33" classes={['flex-middle', 'flex-column', 'margin-bottom-48']}>
            <Akademie
              fill="currentColor"
              width="210"
              height="250"
              className={classNames(theme, 'new-content', {
                'new-content-selected': this.state.selected.includes('Card / Akademie custom'),
              })}
              onClick={e => this.select('Card / Akademie custom')}
            />
            Card / Akademie custom
          </Cell>
          <Cell size="33" classes={['flex-middle', 'flex-column', 'margin-bottom-48']}>
            <AkademieHeader
              fill="currentColor"
              width="210"
              height="250"
              className={classNames(theme, 'new-content', {
                'new-content-selected': this.state.selected.includes('Card / Akademie + header'),
              })}
              onClick={e => this.select('Card / Akademie + header')}
            />
            Card / Akademie + header
          </Cell>
          <Cell size="33" classes={['flex-middle', 'flex-column', 'margin-bottom-48']}>
            <Infothek
              fill="currentColor"
              width="210"
              height="250"
              className={classNames(theme, 'new-content', {
                'new-content-selected': this.state.selected.includes('Card / Infothek'),
              })}
              onClick={e => this.select('Card / Infothek')}
            />
            Card / Infothek
          </Cell>
          <Cell size="33" classes={['flex-middle', 'flex-column', 'margin-bottom-48']}>
            <Infothek
              fill="currentColor"
              width="210"
              height="250"
              className={classNames(theme, 'new-content', {
                'new-content-selected': this.state.selected.includes('Card / Infothek + Icons'),
              })}
              onClick={e => this.select('Card / Infothek + Icons')}
            />
            Card / Infothek + Icons
          </Cell>
        </Row>
      </Column>
    )
  }
}

export default addContent



// WEBPACK FOOTER //
// ./view/Dashboard/addContent.js